module.exports = __webpack_public_path__ + "img/歸戶提示.2345f5b2.png";